export default "__VITE_ASSET__BPwAxQ1e__"